import React from "react";
import "./Popup.css";
import { colors } from "@mui/material";
export const Popup = ({ text, closePopup }) => {
  return (
    <div className="popup-container">
     <div className="popup-body">
      <h1>{text}</h1>
      <button class="my-button" onClick={closePopup}>Close X  </button>
     </div>
    </div>
  );
};